import React from 'react';

const MONTH_LABELS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

/* Returns a CSS class name based on intensity 0-4 */
const intensityClass = (count, max) => {
  if (!count || max === 0) return 'heat-0';
  const ratio = count / max;
  if (ratio < 0.2)  return 'heat-1';
  if (ratio < 0.45) return 'heat-2';
  if (ratio < 0.75) return 'heat-3';
  return 'heat-4';
};

const SeasonalHeatmap = ({ data, loading }) => {
  if (loading) return <div className="chart-loading">Loading seasonal data...</div>;
  if (!data || !data.years || data.years.length === 0) {
    return <div className="chart-empty">No seasonal data available.</div>;
  }

  const { years, cells } = data;
  const maxVal = Math.max(...Object.values(cells).map(Number), 1);

  return (
    <div className="chart-section">
      <div className="heatmap-wrap">
        {/* Column headers: months */}
        <div className="heatmap-grid">
          <div className="heatmap-corner" />
          {MONTH_LABELS.map(m => (
            <div key={m} className="heatmap-month-label">{m}</div>
          ))}

          {years.map(year => (
            <React.Fragment key={year}>
              <div className="heatmap-year-label">{year}</div>
              {MONTH_LABELS.map((_, mIdx) => {
                const key   = `${year}-${mIdx + 1}`;
                const count = cells[key] || 0;
                const cls   = intensityClass(count, maxVal);

                return (
                  <div
                    key={key}
                    className={`heatmap-cell ${cls}`}
                    title={`${MONTH_LABELS[mIdx]} ${year}: ${count} shipment${count !== 1 ? 's' : ''}`}
                    aria-label={`${MONTH_LABELS[mIdx]} ${year}: ${count} shipments`}
                  >
                    {count > 0 && <span className="heatmap-count">{count}</span>}
                  </div>
                );
              })}
            </React.Fragment>
          ))}
        </div>

        {/* Legend */}
        <div className="heatmap-legend">
          <span className="heatmap-legend__label">Less</span>
          <div className="heatmap-cell heat-0 heatmap-legend__cell" />
          <div className="heatmap-cell heat-1 heatmap-legend__cell" />
          <div className="heatmap-cell heat-2 heatmap-legend__cell" />
          <div className="heatmap-cell heat-3 heatmap-legend__cell" />
          <div className="heatmap-cell heat-4 heatmap-legend__cell" />
          <span className="heatmap-legend__label">More</span>
        </div>
      </div>
    </div>
  );
};

export default SeasonalHeatmap;
